import React from "react";
import { formatINR } from "../data/dummyMonthlyLedgerData";
import { FaBuilding, FaArrowUp, FaArrowDown, FaBalanceScale } from "react-icons/fa";

export default function MonthlyLedgerCards({
  openingBalance = 0,
  openingType = "Dr",
  totalDebit = 0,
  totalCredit = 0,
  closingBalance = 0,
  closingType = "Dr",
}) {
  const isOpCr = openingType === "Cr";
  const isClCr = closingType === "Cr";

  return (
    <div className="mls_kpi_row">
      {/* 1. Opening Balance */}
      <div className="mls_kpi_card">
        <div className="mls_kpi_icon_box icon_opening">
          <FaBuilding />
        </div>
        <div className="mls_kpi_content">
          <span className="mls_kpi_label">Opening Balance</span>
          <span className="mls_kpi_value">
            ₹ {formatINR(openingBalance)}
            <span className={isOpCr ? "drcr_text_cr" : "drcr_text_dr"}>
              {openingType}
            </span>
          </span>
        </div>
      </div>

      {/* 2. Total Debit */}
      <div className="mls_kpi_card">
        <div className="mls_kpi_icon_box icon_debit">
          <FaArrowUp />
        </div>
        <div className="mls_kpi_content">
          <span className="mls_kpi_label">Total Debit</span>
          <span className="mls_kpi_value">
            ₹ {formatINR(totalDebit)}
          </span>
        </div>
      </div>

      {/* 3. Total Credit */}
      <div className="mls_kpi_card">
        <div className="mls_kpi_icon_box icon_credit">
          <FaArrowDown />
        </div>
        <div className="mls_kpi_content">
          <span className="mls_kpi_label">Total Credit</span>
          <span className="mls_kpi_value">
            ₹ {formatINR(totalCredit)}
          </span>
        </div>
      </div>

      {/* 4. Closing Balance */}
      <div className="mls_kpi_card">
        <div className="mls_kpi_icon_box icon_closing">
          <FaBalanceScale />
        </div>
        <div className="mls_kpi_content">
          <span className="mls_kpi_label">Closing Balance</span>
          <span className="mls_kpi_value">
            ₹ {formatINR(closingBalance)}
            <span className={isClCr ? "drcr_text_cr" : "drcr_text_dr"}>
              {closingType}
            </span>
          </span>
        </div>
      </div>
    </div>
  );
}
